import * as actionTypes from "../ActionTypes/index";

const initialState = {
  loading: false,
  plans: [],
  dayPlans: [],
  dayPlanDetails: [],
  planLinks: [],
  error: null,
  success: false,
};

const planReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_PLAN_REQUEST:
    case actionTypes.UPDATE_PLAN_REQUEST:
    case actionTypes.DELETE_PLAN_REQUEST:
    case actionTypes.READ_PLAN_REQUEST:
    case actionTypes.SAVE_DAYPLAN_REQUEST:
    case actionTypes.UPDATE_DAYPLAN_REQUEST:
    case actionTypes.DELETE_DAYPLAN_REQUEST:
    case actionTypes.READ_DAYPLAN_REQUEST:
    case actionTypes.SAVE_DAYPLAN_DETAIL_REQUEST: // ADD THIS
    case actionTypes.UPDATE_DAYPLAN_DETAIL_REQUEST: // ADD THIS
    case actionTypes.READ_TWG_PLANS_REQUEST:
    case actionTypes.SAVE_PLANLINK_REQUEST:
    case actionTypes.UPDATE_PLANLINK_REQUEST:
    case actionTypes.DELETE_PLANLINK_REQUEST:
    case actionTypes.READ_PLANLINK_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case actionTypes.SAVE_PLAN_SUCCESS:
      return {
        ...state,
        plans: [...state.plans, action.payload],
        loading: false,
      };
    
    case actionTypes.UPDATE_PLAN_SUCCESS:
      return { ...state, loading: false, success: true, plans: state.plans.map(p => p._id === action.payload._id ? action.payload : p) };
    case actionTypes.DELETE_PLAN_SUCCESS:
      return { ...state, loading: false, success: true, plans: state.plans.filter(p => p._id !== action.payload._id) };
    case actionTypes.READ_PLAN_SUCCESS:
    case actionTypes.READ_TWG_PLANS_SUCCESS:
      return { ...state, loading: false, success: true, plans: action.payload };

    case actionTypes.SAVE_PLANLINK_SUCCESS:
      return { ...state, loading: false, success: true, planLinks: [...state.planLinks, action.payload] };
    case actionTypes.UPDATE_PLANLINK_SUCCESS:
      return { ...state, loading: false, success: true, planLinks: state.planLinks.map(l => l._id === action.payload._id ? action.payload : l) };
    case actionTypes.DELETE_PLANLINK_SUCCESS:
      return { ...state, loading: false, success: true, planLinks: state.planLinks.filter(l => l._id !== action.payload._id) };
    case actionTypes.READ_PLANLINK_SUCCESS:
      return { ...state, loading: false, success: true, planLinks: action.payload };

    case actionTypes.SAVE_DAYPLAN_SUCCESS:
      return { ...state, loading: false, success: true, dayPlans: [...state.dayPlans, action.payload] };
    case actionTypes.UPDATE_DAYPLAN_SUCCESS:
      return { ...state, loading: false, success: true, dayPlans: state.dayPlans.map(d => d._id === action.payload._id ? action.payload : d) };
    case actionTypes.DELETE_DAYPLAN_SUCCESS:
      return { ...state, loading: false, success: true, dayPlans: state.dayPlans.filter(d => d._id !== action.payload._id) };
    case actionTypes.READ_DAYPLAN_SUCCESS:
      return { ...state, loading: false, success: true, dayPlans: action.payload };

    case actionTypes.SAVE_DAYPLAN_DETAIL_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        success: true, 
        dayPlanDetails: [...state.dayPlanDetails, action.payload] 
      };
    
    case actionTypes.UPDATE_DAYPLAN_DETAIL_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        success: true, 
        dayPlanDetails: state.dayPlanDetails.map(d => 
          d._id === action.payload._id ? action.payload : d
        ) 
      };

    case actionTypes.SAVE_PLAN_FAILURE:
    case actionTypes.UPDATE_PLAN_FAILURE:
    case actionTypes.DELETE_PLAN_FAILURE:
    case actionTypes.READ_PLAN_FAILURE:
    case actionTypes.SAVE_DAYPLAN_FAILURE:
    case actionTypes.UPDATE_DAYPLAN_FAILURE:
    case actionTypes.DELETE_DAYPLAN_FAILURE:
    case actionTypes.READ_DAYPLAN_FAILURE:
    case actionTypes.SAVE_DAYPLAN_DETAIL_FAILURE:
    case actionTypes.UPDATE_DAYPLAN_DETAIL_FAILURE:
    case actionTypes.READ_TWG_PLANS_FAILURE:
    case actionTypes.SAVE_PLANLINK_FAILURE:
    case actionTypes.UPDATE_PLANLINK_FAILURE:
    case actionTypes.DELETE_PLANLINK_FAILURE:
    case actionTypes.READ_PLANLINK_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };
      case actionTypes.DELETE_DAYPLAN_DETAIL_REQUEST:
        return { ...state, loading: true, success: false, error: null };
      
      case actionTypes.DELETE_DAYPLAN_DETAIL_SUCCESS:
        return { 
          ...state, 
          loading: false, 
          success: true, 
          dayPlanDetails: state.dayPlanDetails.filter(d => 
            d._id !== action.payload._id
          ) 
        };
      
      case actionTypes.DELETE_DAYPLAN_DETAIL_FAILURE:
        return { ...state, loading: false, success: false, error: action.payload };
      
    default:
      return state;
  }
};

export default planReducer;
